import * as React from "react"
import {Box, Typography} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core"
import {productDetailsEvolutionSelectedSku, productDetailsEvolutionCurrentSkuData, productDetailsEvolutionSkuData} from "../../@signals";


export default function MarketplacesProductDetailsEvolutionSkuPaginator() {
	const numSkus = productDetailsEvolutionSkuData.value.length
	const skuSelectedIndex = productDetailsEvolutionCurrentSkuData.value.idx
	const lastIndex = productDetailsEvolutionSkuData.value[numSkus - 1].idx

	const handleClick = modifier => productDetailsEvolutionSelectedSku.value = productDetailsEvolutionSkuData.value[skuSelectedIndex + modifier].skuID

    return <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
        <ButtonIconSeeker icon="chevron-left" sx={{ fontSize: 10 }} disabled={!skuSelectedIndex} onClick={() => handleClick(-1)} />

		<Typography variant="caption">
			{productDetailsEvolutionCurrentSkuData.value.idx + 1} of {numSkus}
		</Typography>

		<ButtonIconSeeker icon="chevron-right" sx={{ fontSize: 10 }} disabled={lastIndex === skuSelectedIndex} onClick={() => handleClick(1)} />
    </Box>
}